
  document.addEventListener('DOMContentLoaded', function() {
    const accordions = document.querySelectorAll('[data-faq-accordion]');
    
    accordions.forEach(function(accordion) {
      const singleOpen = accordion.getAttribute('data-single-open') === 'true';
      const items = accordion.querySelectorAll('[data-faq-item]');
      
      items.forEach(function(item) {
        const trigger = item.querySelector('[data-faq-trigger]');
        
        if (trigger) {
          trigger.addEventListener('click', function(e) {
            e.preventDefault();
            
            const isActive = item.classList.contains('active');
            
            // If single open mode, close all other items
            if (singleOpen) {
              items.forEach(function(otherItem) {
                if (otherItem !== item) {
                  otherItem.classList.remove('active');
                  const otherTrigger = otherItem.querySelector('[data-faq-trigger]');
                  if (otherTrigger) {
                    otherTrigger.setAttribute('aria-expanded', 'false');
                  }
                }
              });
            }
            
            // Toggle current item
            if (isActive) {
              item.classList.remove('active');
              trigger.setAttribute('aria-expanded', 'false');
            } else {
              item.classList.add('active');
              trigger.setAttribute('aria-expanded', 'true');
            }
          });
        }
      });
    });
  });

  // Reinitialize on Shopify theme editor events
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      const accordions = document.querySelectorAll('[data-faq-accordion]');
      
      accordions.forEach(function(accordion) {
        const singleOpen = accordion.getAttribute('data-single-open') === 'true';
        const items = accordion.querySelectorAll('[data-faq-item]');
        
        items.forEach(function(item) {
          const trigger = item.querySelector('[data-faq-trigger]');
          
          if (trigger) {
            trigger.addEventListener('click', function(e) {
              e.preventDefault();
              
              const isActive = item.classList.contains('active');
              
              if (singleOpen) {
                items.forEach(function(otherItem) {
                  if (otherItem !== item) {
                    otherItem.classList.remove('active');
                    const otherTrigger = otherItem.querySelector('[data-faq-trigger]');
                    if (otherTrigger) {
                      otherTrigger.setAttribute('aria-expanded', 'false');
                    }
                  }
                });
              }
              
              if (isActive) {
                item.classList.remove('active');
                trigger.setAttribute('aria-expanded', 'false');
              } else {
                item.classList.add('active');
                trigger.setAttribute('aria-expanded', 'true');
              }
            });
          }
        });
      });
    });
  }